<script setup>
import PopUp from '~/components/PopUp.vue';
import Close from '~/components/PopUp/Close.vue';
import PopupContent from './PopupContent.vue';
import SubjectDropDownItem from "~/layouts/_components/SubjectDropDownItem.vue";

const [route, router, config, userStore, filterStore, errorStore] = [
  useRoute(),
  useRouter(),
  useRuntimeConfig(),
  useUserStore(),
  useFilterStore(),
  useErrorStore(),
]

const subjects = computed(() => userStore.subjects)
const activeSubject = computed(() => userStore.activeSubject)
const sortedSubjects = computed(() => {
  if (!userStore.activeSubject) return subjects.value
  return [activeSubject.value, ...subjects.value.filter(subject => subject.id !== activeSubject.value.id)];
});

const wasteSubjects = ref(false)
const model = defineModel()
const first = ref(true)
let handleClickOutside;

onMounted(async () => {
  await nextTick();
  const element = document.getElementById('refUl');
  if (element) {
    handleClickOutside = (event) => onClickOutside(event, element);
    document.addEventListener('click', handleClickOutside);
  }
})
onUnmounted(() => {
  if (handleClickOutside) {
    document.removeEventListener('click', handleClickOutside);
  }
})

function onClickOutside(event, element) {
  if (wasteSubjects.value) {
    return
  }

  if (first.value) {
    first.value = false
    return
  }
  if (!element === event.target || !element.contains(event.target)) {
    model.value = false
  }
}

function popupCollectionPointSelected() {
  wasteSubjects.value = false
  model.value = false
}
</script>
<template>
  <ul id="refUl">
    <li>
      <button @click="wasteSubjects = true">{{ $_('navigation.dropdown_collection_points.title', 'Sběrná místa') }}
        <span>({{
            subjects.length || 0
          }})</span></button>
    </li>
    <template v-for="subject in sortedSubjects" :key="subject.id">
      <SubjectDropDownItem :subject="subject" v-on:close="() => model = false"/>
    </template>
  </ul>
  <Teleport to="body">
    <PopUp v-model="wasteSubjects">
      <PopupContent v-on:close="() => popupCollectionPointSelected()"/>
      <Close v-model="wasteSubjects"></Close>
    </PopUp>
  </Teleport>
</template>
<style scoped>
span {
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(128 130 133 / var(--tw-text-opacity))
  /* #808285 */;
}

ul {
  position: absolute;
  background-color: #fff;
  right: 0;
  width: 300px;
  top: 160%;
  z-index: 9999;
  border: 2px solid #EBECEC;
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 2px;
  max-height: 60vh;
  overflow: auto;
}

ul > li {
  --tw-text-opacity: 1;
  color: rgb(55 65 66 / var(--tw-text-opacity))
  /* #374142 */;
  font-weight: 700;
  font-size: 0.875rem
  /* 14px */;
}


li button {
  padding: 12px 16px;
  text-align: left;
}
</style>
